import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import './Register.css';
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import CONFIG from '../config';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function Register() {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [username, setUsername] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [channel, setChannel] = useState('');

  // New: popup state
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');

  const navigate = useNavigate();
  const location = useLocation();

  const [selectedChannels, setSelectedChannels] = useState([]);
const [customChannel, setCustomChannel] = useState('');

const websiteOptions = [
  "www.uficon.com","education.uficon.com",
"huaweihub.uficon.com"]

const [selectedWebsite, setSelectedWebsite] = useState('');
const [isSubmitting, setIsSubmitting] = useState(false);

const branchOptions = [
  'iStudio at Fashion Island',
  'iStudio at The Mall Lifestore Ngamwongwan',
  'iStudio at The Promenade',
  'iStudio at Robinson Trang',
  'iStudio at Terminal 21 Asok',
  'iStudio at Terminal 21 Korat',
  'U•Store at Srinakharinwirot University',
  'U•Store at Mahidol University Faculty of Public Health',
  'U•Store at Siriraj Piyamaharajkarun Hospital',
  'U•Store at Siam University',
  'U•Store at Prince of Songkla University',
  'U•Store at Ubon Ratchathani Rajabhat University',
  'U•Store at Walailak University',
  'U•Store by UFicon at Srinakharinwirot University Ongkharak Campus',
  'U•Store by UFicon at Suratthani Rajabhat University',
  'U•Store by UFicon at Walailak University Hospital',
  'iMedic at Fashion Island',
  'iMedic The Mall Lifestore Ngamwongwan',
  'iMedic Robinson Trang',
  'Huawei Store at The Mall Lifestore Ngamwongwan'
];
const [selectedBranch, setSelectedBranch] = useState('');


const requestOtp = async () => {
  try {
    const response = await axios.post(
      `${CONFIG.API_BASE_URL}/user-line-oa/request-otp`,
      new URLSearchParams({ cust_tel: phone }),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    console.log('OTP Response:', response.data);
    alert(`ส่งรหัส OTP ไปยังเบอร์ ${phone} แล้ว`);
    return response.data.otp_code;
  } catch (error) {
    console.error('OTP request failed:', error);
    alert('ไม่สามารถส่งรหัส OTP ได้ กรุณาลองใหม่');
    throw error;
  }
};


const handleChannelChange = (option) => {
  if (selectedChannels.includes(option)) {
    setSelectedChannels(selectedChannels.filter(item => item !== option));
  } else {
    setSelectedChannels([...selectedChannels, option]);
  }
};


  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const rememberedUsername = localStorage.getItem('username');
    const rememberedPassword = localStorage.getItem('password');
    if (rememberedUsername && rememberedPassword) {
      setUsername(rememberedUsername);
      setPassword(rememberedPassword);
      setRememberMe(true);
    }
  }, [location.search]);

  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };

  const navigateToLogin = () => {
    navigate('/');
  };

  const knownOptions = [
  'Facebook / Instagram',
  'สาขาหน้าร้าน',
  'เว็บไซต์ของร้าน',
  'TikTok',
  'Shopee / Lazada',
  'Google / Google Maps',
  'Line OA',
  'เพื่อนแนะนำ ผ่านมหาวิทยาลัย / โรงเรียน',
  'ผ่านมหาวิทยาลัย / โรงเรียน',
  'ป้าย LED ภายในห้าง',
  'ป้าย LED หน้าห้าง',
  'อื่น ๆ',
];

  // Show the popup with a given message
  const showPopup = (message) => {
    setPopupMessage(message);
    setPopupVisible(true);
  };

  // Hide the popup
  const hidePopup = () => {
    setPopupVisible(false);
    setPopupMessage('');
  };

  const handleSubmit = async () => {
    setIsSubmitting(false);
    const policyCheck = document.getElementById('policyCheck');

    // 1. Check that all fields are non-empty
    if (!username.trim()) {
      showPopup('กรุณากรอกอีเมล');
      return;
    }
    if (!password) {
      showPopup('กรุณากรอกรหัสผ่าน');
      return;
    }
    if (!firstName.trim()) {
      showPopup('กรุณากรอกชื่อจริง');
      return;
    }
    if (!lastName.trim()) {
      showPopup('กรุณากรอกนามสกุล');
      return;
    }
    if (!phone) {
      showPopup('กรุณากรอกเบอร์โทรศัพท์');
      return;
    }
    if (!birthDate) {
      showPopup('กรุณาเลือกวันเกิด');
      return;
    }

    const finalChannelList = selectedChannels.includes('อื่น ๆ')
  ? [...selectedChannels.filter(c => c !== 'อื่น ๆ'), customChannel.trim()]
  : selectedChannels;

if (finalChannelList.length === 0 || finalChannelList.some(c => !c)) {
  showPopup('กรุณาเลือกหรือกรอกช่องทางที่ทราบร้าน');
  return;
}

    if (!policyCheck.checked) {
      showPopup('กรุณากดยอมรับนโยบายความเป็นส่วนตัวและข้อกำหนดการใช้');
      return;
    }


    // 2. Validate phone length (exactly 10 digits)
    const phoneDigits = phone.replace(/\D/g, '');
    if (phoneDigits.length !== 10) {
      showPopup('เบอร์โทรศัพท์ต้องมี 10 หลัก');
      return;
    }

    // 3. Validate password rules
    const passwordMinLength = 12;
    const hasUpperCase = /[A-Z]/;
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
    if (
      password.length < passwordMinLength ||
      !hasUpperCase.test(password) ||
      !hasSpecialChar.test(password)
    ) {
      showPopup('รหัสผ่านต้องมีความยาวอย่างน้อย 12 ตัว พิมพ์ใหญ่ 1 ตัว และอักขระพิเศษ 1 ตัว');
      return;
    }

    
    if (isSubmitting) return; // prevent double submission
    setIsSubmitting(true);

    try {

      // const otp = await requestOtp();

      //   // 👉 Show a simple browser prompt to ask user for the OTP code
      //   const userEnteredOtp = prompt("กรุณากรอกรหัส OTP ที่คุณได้รับ:");

      //   if (userEnteredOtp !== otp) {
      //     alert("รหัส OTP ไม่ถูกต้อง");
      //     setIsSubmitting(false);
      //     return;
      //   }
      // 4. Build FormData for user-line-oa/create
      const url = 'https://sso-uficon-xuvbdxggia-uc.a.run.app/register';
      const userLogin = username.split('@')[0];

      const postData = new FormData();
      postData.append("invbill", "Uficon");
      postData.append("birthdate", birthDate);
      postData.append("invcust_name", `${firstName} ${lastName}`);
      postData.append("cust_tel", phoneDigits);
      postData.append("is_policy_accepted", policyCheck.checked);
      postData.append("channel", channel);
      postData.append("line_user_id", localStorage.getItem('line_user_id'));
      postData.append("email", username);

      
      const createRes = await axios.post(
        `${CONFIG.API_BASE_URL}/user-line-oa/create`,
        postData
      );
      // The response payload is assumed to be { message: "...", id: <newId> }
      const newUserId = createRes.data.id;
      console.log("Created user with ID:", newUserId);

      // 2) Fetch all “point events” from /coupon/
      //    (adjust the query‐string exactly as your backend expects)
      const couponRes = await axios.get(
        `${CONFIG.API_BASE_URL}/point-events/`,
        {
          params: {
            page: 1,
            limit: 1000
          }
        }
      );
      const events = couponRes.data.content.data; 
      // events is an array of objects like { event_id, target_register, reward_value_fixed, start_at, end_at, ... }

      // 3) For each event that has target_register=true AND now ∈ [start_at, end_at], call add-point
      const now = new Date();
      for (const ev of events) {
        // Check if this event qualifies
        if (ev.target_register) {
          const start = new Date(ev.start_at);
          const end = new Date(ev.end_at);
          if (now >= start && now <= end) {
            const increment = ev.reward_value_fixed || 0;
            if (increment > 0) {
              try {
                // We send as x-www-form-urlencoded: increment=<number>
                await axios.post(
                  `${CONFIG.API_BASE_URL}/user-line-oa/add-point/${newUserId}`,
                  new URLSearchParams({ increment: increment.toString() }),
                  {
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                    }
                  }
                );
                console.log(`Added ${increment} points for event ${ev.event_id}`);
              } catch (err) {
                console.error(`Failed to add ${increment} points for event ${ev.event_id}:`, err);
              }
            }
          }
        }
      }

      await manualAddCoupon();

      // 5. Check user existence
      const checkResponse = await axios.post(
        `https://sso-uficon-xuvbdxggia-uc.a.run.app/check-user?user_login=${userLogin}`
      );

      // 6. Register on sso endpoint
      const payload = new URLSearchParams({
        user_login: checkResponse.data.user_login,
        user_email: username,
        user_pass: password,
        display_name: checkResponse.data.user_login,
        user_nicename: checkResponse.data.user_login,
        is_policy_accepted: policyCheck.checked.toString(),
        channel: channel,
      });
      try{
          await axios.post(url, payload, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });
      }catch (err) {
        console.error("Error registering user:", err);
      }
   

      // 7. Immediately log in
      const loginParams = new URLSearchParams();
      loginParams.append('username', username);
      loginParams.append('password', password);

      try{
      const loginResponse = await axios.post(
        'https://sso-uficon-xuvbdxggia-uc.a.run.app/login',
        loginParams,
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );

      }catch (err) {
        console.log("Error logging in:", err);
      }




      // 8. Remember credentials if needed
      if (rememberMe) {    
        localStorage.setItem('username', username);
        localStorage.setItem('password', password);

      } else {
        localStorage.removeItem('username');
        localStorage.removeItem('password');
      }

      // 9. Redirect to login page (or wherever you need)
      navigate('/');
      setIsSubmitting(false);
    } catch (error) {
      console.error('Error posting to API:', error);
      setPopupMessage('ขออภัย! คุณมีข้อมูลในระบบแล้ว หรือ มีข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง');
      setPopupVisible(true);
    } finally {
      setIsSubmitting(false);
      navigate('/');
    }
  };

  // Function to force redeem a coupon
  const forceRedeemCoupon = async (couponId) => {
    try {
      const response = await axios.post(
        `${CONFIG.API_BASE_URL}/coupon/force_redeem_coupon`,
        null,
        {
          params: {
            line_user_id: localStorage.getItem('line_user_id'),
            coupon_id: couponId
          },
          headers: {
            accept: 'application/json'
          }
        }
      );
      console.log("Force redeem coupon succeeded:", response.data);
    } catch (error) {
      console.error("Force redeem coupon failed:", error);
    }
  };

  async function manualAddCoupon() {
    await forceRedeemCoupon(56);
    await forceRedeemCoupon(58);
    await forceRedeemCoupon(61);
    await forceRedeemCoupon(62);

  }
  

  return (
    <div>

          {isSubmitting ? 
          <div style={{ marginTop: '10px', textAlign: 'center', color: '#00a9a5' }}>
            กำลังดำเนินการ โปรดรอสักครู่...
          </div> :       <header>
        <div style={{ width: '100%', backgroundColor: '#f2f3f5' }}>
          <div style={{ padding: '50px' }}>
            <img src="/assets/logo U-01.png" alt="Logo" className="logo" />
            <div className="welcome-text">Welcome to iStudio by UFicon</div>
            <div className="login-header">สมัครสมาชิก</div>

            {/* Email */}
            <div className="input-group-userinput">
              <ul style={{ marginTop: '15px', color: 'grey', listStyleType: 'none', paddingLeft: 0 }}>
            <li>Your Email</li>
          </ul>
              <input
                type="text"
                className="input-field"
                placeholder="example@email.com"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            {/* Password */}
          

            <div className="input-group-userinput">

              {/* <div className="input-label">Password</div> */}
                <ul style={{ marginTop: '15px', color: 'grey', listStyleType: 'none', paddingLeft: 0 }}>
            <li>Password</li>
          </ul>
              <div className="password-container" style={{ position: 'relative' }}>
                <input
                  type={showPassword ? "text" : "password"}
                  className="input-field"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  onClick={togglePasswordVisibility}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '65%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer'
                  }}
                >
                  {showPassword ? <IoEyeOffOutline size={20} /> : <IoEyeOutline size={20} />}
                </span>
              </div>
              <ul style={{ marginTop: '8px', paddingLeft: '20px', fontSize: '11px', color: 'grey' }}>
                <li>ต้องมีตัวอักษรภาษาอังกฤษ (a-z,A-Z) และตัวเลขรวมกันอย่างน้อย 12 ตัว</li>
                <li>ต้องมีตัวอักษรภาษาอังกฤษพิมพ์ใหญ่ (A-Z) ในรหัสผ่านอย่างน้อย 1 ตัว</li>
                <li>ต้องมีตัวอักษรพิเศษอย่างน้อย 1 ตัว เช่น !"?$%^&@*</li>
              </ul>
            </div>

            {/* First Name */}
            <div className="input-group-userinput">
              <ul style={{ marginTop: '15px', color: 'grey', listStyleType: 'none', paddingLeft: 0 }}>
            <li>ชื่อจริง</li>
          </ul>
              <input
                type="text"
                className="input-field"
                placeholder="ชื่อจริง"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>

            {/* Last Name */}
            <div className="input-group-userinput">
              <ul style={{ marginTop: '15px', color: 'grey', listStyleType: 'none', paddingLeft: 0 }}>
            <li>นามสกุล</li>
          </ul>
              <input
                type="text"
                className="input-field"
                placeholder="นามสกุล"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>

            {/* Phone */}
            <div className="input-group-userinput">
              <ul style={{ marginTop: '15px', color: 'grey', listStyleType: 'none', paddingLeft: 0 }}>
            <li>เบอร์โทรศัพท์</li>
          </ul>
              <input
                type="tel"
                className="input-field"
                placeholder="0812345678"
                value={phone}
                onChange={(e) => {
                  const input = e.target.value;
                  const digitsOnly = input.replace(/\D/g, '');
                  if (digitsOnly.length <= 10) {
                    setPhone(digitsOnly);
                  }
                }}
              />
            </div>

            {/* Birth Date */}
            <div className="input-group-userinput">
  <ul style={{ marginTop: '15px', color: 'grey', listStyleType: 'none', paddingLeft: 0 }}>
    <li>วันเกิด</li>
  </ul>
  <div className="datepicker-wrapper">
    <DatePicker
      selected={birthDate ? new Date(birthDate) : null}
      onChange={(date) => {
        if (date) setBirthDate(date.toISOString().split('T')[0]);
      }}
      dateFormat="yyyy-MM-dd"
      className="input-field"
      placeholderText="เลือกวันเกิด"
      maxDate={new Date()}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      popperPlacement="bottom"
    />
  </div>
</div>


            {/* Channel */}
           <div className="input-group-userinput">
  <ul style={{ marginTop: '15px', color: 'grey', listStyleType: 'none', paddingLeft: 0 }}>
    <li>ท่านรู้จักร้าน iStudio / U•Store by UFicon ผ่านช่องทางใด</li>
  </ul>

  <div style={{ paddingLeft: '10px', paddingTop: '10px' }}>
    {knownOptions.map((option) => (
      <div key={option} style={{ marginBottom: '8px' }}>
        <label style={{ display: 'flex', alignItems: 'center', fontFamily: 'Prompt', fontSize: '14px' }}>
          <input
            type="checkbox"
            checked={selectedChannels.includes(option)}
            onChange={() => handleChannelChange(option)}
            style={{ marginRight: '10px' }}
          />
          {option}
        </label>
       {option === 'อื่น ๆ' && selectedChannels.includes('อื่น ๆ') && (
  <input
    className="input-field"
    type="text"
    placeholder="โปรดระบุช่องทางอื่น ๆ"
    value={customChannel}
    onChange={(e) => setCustomChannel(e.target.value)}
    style={{ marginTop: '10px', marginLeft: '30px' }}
  />
)}

{option === 'สาขาหน้าร้าน' && selectedChannels.includes('สาขาหน้าร้าน') && (
  <div style={{ marginTop: '10px', marginLeft: '30px' }}>
    <select
      value={selectedBranch}
      onChange={e => setSelectedBranch(e.target.value)}
      style={{
        width: '100%',
        padding: '8px',
        fontSize: '12px',
        fontFamily: 'Prompt',
        borderRadius: '4px',
        border: '1px solid #ccc',
        boxSizing: 'border-box',
      }}
    >
      <option value="" disabled>-- กรุณาเลือกสาขา --</option>
      {branchOptions.map(branch => (
        <option key={branch} value={branch}>
          {branch}
        </option>
      ))}
    </select>
  </div>
)}


{option === 'เว็บไซต์ของร้าน' && selectedChannels.includes('เว็บไซต์ของร้าน') && (
  <div style={{ marginTop: '10px', marginLeft: '30px' }}>
    {websiteOptions.map(site => (
      <div key={site} style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
        <label style={{ fontSize: '12px', fontFamily: 'Prompt', display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            checked={selectedWebsite.includes(site)}
            onChange={() => {
              if (selectedWebsite.includes(site)) {
                setSelectedWebsite(selectedWebsite.filter(s => s !== site));
              } else {
                setSelectedWebsite([...selectedWebsite, site]);
              }
            }}
            style={{ marginRight: '8px' }}
          />
          {site}
        </label>
      </div>
    ))}
  </div>
)}





      </div>
    ))}
  </div>
</div>



            {/* Policy Checkbox */}
            <div className="policy-header-register" style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                id="policyCheck"
                style={{
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  appearance: 'none',
                  border: '1px solid grey',
                  outline: 'none',
                  cursor: 'pointer',
                  marginRight: '8px',
                  backgroundColor: 'white',
                  position: 'relative'
                }}
                onChange={(e) => {
                  const checkbox = e.target;
                  if (checkbox.checked) {
                    checkbox.style.backgroundColor = 'grey';
                    checkbox.style.backgroundImage =
                      'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'white\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\' class=\'feather feather-check\'%3E%3Cpath d=\'M20 6L9 17l-5-5\'/%3E%3C/svg%3E")';
                    checkbox.style.backgroundSize = '12px 12px';
                    checkbox.style.backgroundPosition = 'center';
                    checkbox.style.backgroundRepeat = 'no-repeat';
                  } else {
                    checkbox.style.backgroundColor = 'white';
                    checkbox.style.backgroundImage = 'none';
                  }
                }}
              />
              <div>
                <div>
                  ฉันได้อ่านและยอมรับ&nbsp;
                  <a
                    onClick={() => navigate('/privacy-and-policy')}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#00a9a5', textDecoration: 'none' }}
                  >
                    นโยบายความเป็นส่วนตัว
                  </a>
                  &nbsp;และ
                </div>
                <div>
                  <a
                    onClick={() => navigate('/term-and-conditions')}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#00a9a5', textDecoration: 'none' }}
                  >
                    ข้อกำหนดการใช้
                  </a>
                  &nbsp;ของบริษัท ยูฟิคอน จำกัด
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="input-group-userinput">
              <button onClick={handleSubmit} className="login-button">
                ลงทะเบียน
              </button>
            </div>

            {/* Already a member link */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Prompt',
                fontSize: '13px',
                marginTop: '10px'
              }}
            >
              <div style={{ color: 'grey', padding: '10px' }}>เป็นสมาชิกอยู่แล้ว,</div>
              <div style={{ color: '#00a9a5', fontWeight: 'bold' }} onClick={navigateToLogin}>
                เข้าสู่ระบบ
              </div>
            </div>
          </div>
        </div>
      </header>
        }



      {/* Custom Popup Modal */}
      {popupVisible && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              maxWidth: '90%',
              width: '320px',
              textAlign: 'center',
              boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
            }}
          >
            <div style={{ marginBottom: '16px', fontSize: '16px', color: '#333' }}>
              {popupMessage}
            </div>
            <button
              onClick={hidePopup}
              style={{
                padding: '8px 16px',
                backgroundColor: '#00a9a5',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              ตกลง
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Register;
